import { Banner, Box, Button, InlineStack, Text } from '@shopify/polaris';
import { useNavigate } from 'react-router-dom';
import { useLegacyMode } from './LegacyModeContext';

const LegacyModeBanner = () => {
    const navigate = useNavigate();
    const { isLegacy } = useLegacyMode();
    if (!isLegacy) return null;

    return (
        <Box paddingBlockEnd="400">
            <Banner title="Legacy PartFinder mode" tone="info">
                <InlineStack align="space-between" blockAlign="center" gap="300" wrap>
                    <Text as="p">
                        Your current storefront behavior and vehicle tags are being preserved by the new app.
                    </Text>
                    <Button onClick={() => navigate('/legacy/upgrade')}>Review upgrade</Button>
                </InlineStack>
            </Banner>
        </Box>
    );
};

export default LegacyModeBanner;
